/* Twee kleine gedragingen bij de personalisatievelden. Ze zitten in één bestand
   omdat snippets/napkin-option-field.liquid dit al op elke productpagina laadt;
   een tweede asset zou een tweede script-tag in dat snippet betekenen.

   1. DE GEKOZEN WAARDE NAAST DE KOP: PLATE COLOR * · Orange.

   Bij kleuren en vormen is het staaltje het enige wat de klant ziet. Twee tinten
   roze naast elkaar zijn op een scherm nauwelijks te onderscheiden, en op de
   bestelling komt straks een woord te staan - niet een plaatje. Wie 'Magenta'
   bedoelde maar 'Hot pink' aanklikte, merkt dat nu meteen in plaats van bij de
   proef.

   2. "SEE THE FONT CHART IN THE PHOTOS" SPRINGT NAAR DIE FOTO.

   Het fontoverzicht is bij elk product de laatste foto in de galerij. Die zin
   stond er als kale tekst, dus de klant moest zelf door de foto's bladeren om te
   zien waar Font 3 op lijkt - precies op het moment dat hij aan het kiezen is.

   ALLEEN DIE ENE ZIN WORDT KLIKBAAR, niet de hele uitleg. Bij de onderzetters
   staat er achteraan "Leave blank if you're uploading your own design", en die
   zin heeft niets met de galerij te maken; onderstreept meegenomen suggereerde
   hij dat er iets anders gebeurt dan er staat. Vandaar dat de tekst hier op
   zinsgrens wordt gesplitst en alleen het deel met "font chart" een knop wordt.

   De zin wordt hier tot knop gemaakt in plaats van in de zes blokken die hem
   renderen. Dat scheelt zes bestanden aanpassen, en als de tekst ooit verandert
   hoeft er maar op één plek iets bij.

   Het springen zelf gaat in drie stappen, van net naar grof, want Horizon's
   galerij is een web component en de API daarvan kan met een themaupdate
   veranderen:
     a. de slideshow zelf via select()
     b. anders de laatste miniatuur of stip aanklikken - dat zijn gewone knoppen
     c. anders de laatste slide in beeld scrollen
   Lukt geen van drie, dan blijft de zin gewoon staan als tekst. Kapot gaat het
   dus nooit.

   Werkt via delegatie op document, dus het maakt niet uit hoeveel velden er op
   de pagina staan of dat een blok later opnieuw rendert. Een dubbele script-tag
   is onschadelijk: de browser haalt het bestand één keer op en de guard hieronder
   voorkomt dat de listeners twee keer hangen. */
(function () {
  'use strict';
  if (window.__napkinChosenReady) return;
  window.__napkinChosenReady = true;

  /* ---------- 1. gekozen waarde naast de kop ---------- */

  function label(radio) {
    if (!radio) return '';
    return radio.value || '';
  }

  function update(field) {
    var out = field.querySelector('.napkin-options__chosen');
    if (!out) return;
    var checked = field.querySelector('.napkin-options__radio:checked');
    var value = label(checked);
    out.textContent = value ? '\u00b7 ' + value : '';
  }

  function refresh(root) {
    (root || document).querySelectorAll('.napkin-options__field').forEach(update);
  }

  /* ---------- 2. naar het fontoverzicht ---------- */

  function gallery() {
    return document.querySelector('media-gallery');
  }

  function showLastMedia() {
    var root = gallery();
    if (!root) return false;

    var slides = root.querySelectorAll('slideshow-slide');
    var last = slides.length - 1;
    if (last < 0) return false;

    /* a. de component zelf */
    try {
      var show = root.slideshow;
      if (show && typeof show.select === 'function') {
        show.select(last);
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }
    } catch (e) {
      /* De galerij is een web component; als de API wijzigt vallen we door. */
    }

    /* b. de laatste miniatuur of stip. Alleen zichtbare bediening, want
       desktop en mobiel hebben elk hun eigen set en de verborgene reageert niet. */
    var controls = root.querySelectorAll('slideshow-controls');
    for (var i = 0; i < controls.length; i++) {
      if (!controls[i].offsetParent) continue;
      var buttons = controls[i].querySelectorAll('button');
      if (buttons.length !== slides.length) continue;
      buttons[last].click();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }

    /* c. gewoon ernaartoe scrollen */
    slides[last].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    return true;
  }

  function escapeHtml(text) {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* Maakt van de zin met "font chart" een knop, en laat de rest van de uitleg
     met rust. Alleen als er meer dan één foto is: bij één foto is er geen
     fontoverzicht en zou de knop niets doen. */
  function armFontLinks(root) {
    var scope = root || document;
    var slides = document.querySelectorAll('media-gallery slideshow-slide');
    if (slides.length < 2) return;

    scope.querySelectorAll('.napkin-options__helper, .napkin-picker__helper').forEach(function (node) {
      if (node.dataset.fontLink) return;

      var text = node.textContent;
      var match = text.match(/[^.!?]*font chart[^.!?]*[.!?]?/i);
      if (!match) return;

      var phrase = match[0].trim();
      var start = text.indexOf(phrase);
      if (start < 0) return;

      node.dataset.fontLink = 'true';
      node.innerHTML =
        escapeHtml(text.slice(0, start)) +
        '<span class="napkin-options__fontlink" role="button" tabindex="0">' +
        escapeHtml(phrase) +
        '</span>' +
        escapeHtml(text.slice(start + phrase.length));
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.napkin-options__fontlink');
    if (!trigger) return;
    event.preventDefault();
    showLastMedia();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var trigger = event.target.closest('.napkin-options__fontlink');
    if (!trigger) return;
    event.preventDefault();
    showLastMedia();
  });

  /* ---------- opstart ---------- */

  document.addEventListener('change', function (event) {
    var radio = event.target.closest('.napkin-options__radio');
    if (!radio) return;
    var field = radio.closest('.napkin-options__field');
    if (field) update(field);
  });

  function start() {
    refresh();
    armFontLinks();
  }

  document.addEventListener('shopify:section:load', start);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
